import { DataTestPanel } from './DataTestPanel';
import { DataTestProvider } from './DataTestProvider';
import { DataTestContextProvider } from './useDataTest/DataTestContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export function DataTest(props) {
  return /*#__PURE__*/_jsx(DataTestProvider, {
    children: /*#__PURE__*/_jsx(DataTestContextProvider, Object.assign({}, props, {
      children: /*#__PURE__*/_jsx(DataTestPanel, {})
    }))
  });
}